import React from 'react';

export const DownTrend = () => <div className={'down-trend'}/>;
